import { NetworkStatus } from '@material-bank/graphql-client'

// "Settled" in the Promise sense: the network request has finished, whether it
// resolved with data or rejected with an error.
export function isSettled(networkStatus: NetworkStatus): boolean {
  return (
    networkStatus === NetworkStatus.ready ||
    networkStatus === NetworkStatus.error
  )
}
